import React, {ReactElement, ReactNode} from 'react';
import classNames from 'classnames';
import Tab from "./Tab";
import PropsProxy from "./PropsProxy";
import {TabContentPropsType} from "./TabContent";

export type TabsPropsType = {
    currentTab?: string|number|symbol,
    defaultTab?: string|number|symbol,
    onTabChange?: (currentTab: string|number|symbol) => void,
    disabled?: boolean,
    tab?: () => ReactNode,
    className?: string|string[]|Record<string, any>,
    extraTabsLocation?: "before"|"after",
    extraTabs?: any,
    renderAll?: boolean,
    collapsable?: boolean,
    children: ReactElement<TabContentPropsType>[],
    pills?: boolean,
    fill?: boolean,
}

type TabsStateType = {
    currentTab: string|number|symbol
}

class Tabs extends React.Component<TabsPropsType, TabsStateType> {
    constructor(props: TabsPropsType) {
        super(props);
        this.state = {
            currentTab: props.currentTab !== undefined ? props.currentTab : props.defaultTab
        };
    }

    existsTab = (props?: TabsPropsType, state?: TabsStateType) => {
        props = props || this.props;
        state = state || this.state;
        let existsTab = false;
        React.Children.map(props.children, child => {
            if (child === null) return child;
            if (((child || {}).props || {}).tabName === state.currentTab)  {
                existsTab = true;
            }
        });
        return existsTab;
    }

    componentDidUpdate(prevProps: TabsPropsType, prevState: TabsStateType) {
        let existsTab = this.existsTab();
        if (prevProps.currentTab !== this.props.currentTab || existsTab !== this.existsTab(prevProps, prevState)) {
            this.setState({
                currentTab: this.props.currentTab !== undefined ? this.props.currentTab : (existsTab ? (this.state.currentTab || this.props.defaultTab) : this.props.defaultTab)
            });
        }
    }

    setActiveTab = async (e: React.MouseEvent, currentTab: string|number|symbol) => {
        e && e.preventDefault();
        if (this.props.disabled) {
            return;
        }
        if (currentTab === this.state.currentTab) {
            if (this.props.collapsable === undefined ? false : this.props.collapsable) {
                this.setState({currentTab: null});
            }
            return;
        }
        if (this.props.onTabChange) {
            try {
                await this.props.onTabChange(currentTab);
                this.setState({currentTab});
            } catch (e) {
                throw e;
            }
        } else {
            this.setState({currentTab});
        }
    }

    render() {
        const currentTab = this.state.currentTab;
        // @ts-ignore
        const CurrentTab: ReactElement|null = this.props.renderAll ? null : React.Children.toArray(this.props.children).find<ReactElement>((child: React.ReactElement) => child.props.tabName === currentTab);
        return (
            <div className={classNames("nav-tabs-custom", this.props.className)}>
                <ul className={classNames("nav", {"nav-tabs": !this.props.pills, "nav-pills": !!this.props.pills, "nav-fill": !!this.props.fill})}>
                    {this.props.extraTabsLocation === "before" && this.props.extraTabs}
                    {React.Children.map(this.props.children, child => {
                            if(child === null) return child;
                            const tabName = child?.props?.tabName;
                            let TabComponent = Tab;
                            if (this.props.tab) {
                                return <PropsProxy
                                    currentTab={currentTab}
                                    tabLabel={child.props.tabLabel}
                                    tabName={tabName}
                                    onClick={this.setActiveTab}
                                >
                                    {this.props.tab}
                                </PropsProxy>
                            }
                            return (
                                <TabComponent
                                    currentTab={currentTab}
                                    tabLabel={child.props.tabLabel}
                                    disabled={child.props.disabled}
                                    tabName={tabName}
                                    onClick={this.setActiveTab}
                                >
                                    {child.props.tabLabel}
                                </TabComponent>
                            );
                        }
                    )}
                    {this.props.extraTabsLocation !== "before" && this.props.extraTabs}
                </ul>
                {this.props.renderAll ? React.Children.toArray(this.props.children).map((Child: ReactElement<TabContentPropsType>, idx) => {
                    return <Child.type key={idx} {...Child.props} active={Child.props.tabName === currentTab} />
                }) : CurrentTab && <CurrentTab.type {...CurrentTab.props} active={true} />}
            </div>
        );
    }
}

export default Tabs;